<script setup lang="ts">
import { onErrorCaptured, ref } from 'vue'

/**
 * Aísla el render de un subárbol: si un hijo revienta en render, atrapa el error,
 * muestra un fallback y NO propaga (return false) → los hermanos y el resto de la
 * lista siguen pintando. Evita que un solo ítem con data rara (p. ej. un rating de
 * proveedor no mapeado) tumbe toda la lista de resultados.
 */
const failed = ref(false)

onErrorCaptured((err) => {
	failed.value = true
	console.error('[ErrorBoundary] render de ítem aislado por error:', err)
	return false
})
</script>

<template>
	<slot v-if="!failed" />
	<slot v-else name="fallback">
		<div
			class="rounded-lg border border-gray-200 bg-gray-50 p-3 text-xs text-gray-400"
		>
			No se pudo mostrar este resultado.
		</div>
	</slot>
</template>
